// extracted by mini-css-extract-plugin
export default {"control":"control_control__Pd246","pdUpload":"control_pdUpload__cg6fZ","previewInput":"control_previewInput__jBsyz"};